import { ITicketGroup } from "meta/backendControlled/structure/ticket";

 export const getUniqueTypeTicketsIds = (items: ITicketGroup[]): number[] => [
   ...new Set(items.flatMap((item) => item.typeTicketIds)),
 ]